export function isGuaranteeSelected(
  selectedIds: number[] | null | undefined,
  id: number
): boolean {
  if (!selectedIds || selectedIds.length === 0) return false;
  return selectedIds.some((item) => item === id);
}

export function buildGuaranteeToggleEvent(id: number, selected: boolean) {
  return {
    target: {
      checked: selected,
      value: String(id),
    },
  };
}
